import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Upload } from 'react-feather'
import {
  withStyles,
} from '@material-ui/core/styles'
import { useFormInput } from '../../hooks/useFormInput'
import { addTicket } from '../../app/slices/ticketsSlice'
// import { CssTextField } from '../../utils/CustomInputs'
import FileInput from '../../components/FileInput'

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '20px',
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(TextField)

const useStyle = makeStyles(() => ({
  root: {},
  fileInput: {
    opacity: 0,
  },

  cardWrap: {
    borderRadius: '20px',
    maxWidth: '51%',
  },
  button: {
    borderRadius: '20px',
  },
  title: {
    fontWeight: 600,
  },
}))

export const TicketForm = () => {
  const classes = useStyle()
  const ticket = useFormInput('')
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [file, setFile] = useState()

  const handleSelectFile = (selectedFile) => {
    setFile(selectedFile[0])
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    dispatch(addTicket(
      {
        question: ticket.value,
        file,
      },
      navigate,
    ))
  }

  return (
    <form onSubmit={handleSubmit} className={classes.root}>
      <Grid container justify="center">
        <Card
          className={classes.cardWrap}
        >
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  className={classes.title}
                >
                  ایجاد تیکت پشتیبانی

                </Typography>
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  {...ticket}
                  fullWidth
                  label="عنوان تیکت"
                  type="text"
                  size="small"
                  variant="outlined"
                  multiline
                  rows={4}
                  rowsMax={10}
                />
              </Grid>
              <Grid item xs={12}>
                <FileInput label="انتخاب فایل" onChange={handleSelectFile} />
              </Grid>
              <Grid container justify="flex-end" item xs={12}>
                <Button startIcon={<Upload size={16} />} className={classes.button} type="submit" variant="contained" color="primary">ایجاد تیکت</Button>
              </Grid>

            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </form>
  )
}

export default TicketForm
